export enum BasicFieldType {
  EMAIL,
  PASSWORD,
  SLUG,
  PHONE,
  SELECT,
  UPLOAD,
  TEXT,
  FULLNAME,
  URL,
  DATE
}
export enum EmailFieldTypes {
  ALLOW_ALL = 'ALLOW_ALL',
  ALLOW_SPECIFIC = 'ALLOW_SPECIFIC',
  BAN_SPECIFIC = 'BAN_SPECIFIC',
  BAN_FREE = 'BAN_FREE'
}
